import { generateTable } from '../..';
import { defineFilter } from '../../../helpers';
var clientSide = defineFilter(true).startsWith('name', 'name').equals('status', 'status').end();

var dataSource = function dataSource(_ref) {
  var run = _ref.run;
  return {
    clientSide: clientSide,
    fn: function fn() {
      return Promise.resolve(run);
    },
    params: function params() {
      return [];
    },
    transform: function transform(result) {
      return {
        data: result.tasks
      };
    }
  };
};

var filters = function filters() {
  return function () {
    return [{
      name: 'name',
      label: 'Name',
      type: 'text'
    }, {
      name: 'status',
      label: 'status',
      type: 'text'
    }];
  };
};

var columns = [{
  value: 'nodeName',
  title: 'Node Name',
  sortable: true
}, {
  value: 'nodeId',
  title: 'Node ID',
  sortable: true
}, {
  value: 'status',
  title: 'Status',
  sortable: true
}, {
  value: 'createdAt',
  title: 'Created',
  sortable: true
}];
export var RunTaskTable = generateTable({
  tableOptions: ['run'],
  dataSource: dataSource,
  filters: filters,
  columns: columns
});
RunTaskTable.displayName = 'RunTaskTable';